

class Modal {
    constructor() {
        this.modals = document.querySelectorAll('.modal');
        this.modalTriggers = document.querySelectorAll('.modal-trigger');
        this.trigger = null;

        this.events();
    }

    events() {
        this.modalTriggers.forEach(m => {
            m.addEventListener('click', this.openModal);
        });

        this.modals.forEach(m => {
            m.querySelector('.modal__close').addEventListener('click', this.closeModal);
            m.querySelector('.subscribe__email--submit').addEventListener('click', this.submitModal);
        })
    }

    openModal = e => {
        this.trigger = e.target;
        const modalID = e.target.dataset.modal;
        const modal = document.getElementById(modalID);
        modal.querySelector('.modal__event-name').innerHTML = e.target.dataset.title;
        modal.querySelector('.subscribe__email--submit').setAttribute('data-modalid', modalID);
        modal.querySelector('.modal__event-id').value = e.target.dataset.id;
        modal.classList.add('modal--show');
        modal.querySelector('.subscribe__email--input').focus();
    }

    closeModal = e => {
        const modal = e.target.closest('.modal');
        modal.classList.remove('modal--show');
    }

    submitModal = e => {
        this.closeModal(e);
        // do the post
        const modalID = e.target.dataset.modalid;
        const modal = document.getElementById(modalID);
        console.log({
            email: modal.querySelector('.subscribe__email--input').value,
            event_id: modal.querySelector('.modal__event-id').value
        })
        // use fetch to post to the api
        fetch(window.location.href + '/rsvp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: modal.querySelector('.subscribe__email--input').value,
                event_id: modal.querySelector('.modal__event-id').value
            })
        }).then(res => {
            if (res.status === 200) {
                this.trigger.nextElementSibling.classList.remove('modal__success--hide');
                this.trigger.classList.add('modal-trigger--hide');
            } else {
                alert('There was an error subscribing to this event. Please try again later.');
            }
        }).catch(err => {
            alert('There was an error subscribing to this event. Please try again later.');
        })
    }

}

export default Modal;
